import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { BrandProvider } from './contexts/BrandContext';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Diagnose from './pages/Diagnose';
import Components from './pages/Components';
import Schematics from './pages/Schematics';
import Projects from './pages/Projects';
import Learn from './pages/Learn';
import Studio from './pages/Studio';
import Drones from './pages/Drones';
import Upgrade from './pages/Upgrade';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Recipes from './pages/Recipes';

export default function App() {
  return (
    <BrandProvider>
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/diagnose" element={<Diagnose />} />
              <Route path="/components" element={<Components />} />
              <Route path="/schematics" element={<Schematics />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/drones" element={<Drones />} />
              <Route path="/upgrade" element={<Upgrade />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/recipes" element={<Recipes />} />

              {/* Catch-all: Redirect to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </BrandProvider>
  );
}
